import NotificationTypes from '../constants/notification';

const initialState = {
    franchNotificationPayments: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case NotificationTypes.SET_NOTIFICATION_FRANCH_PAYMENT:
            return {
                ...state,
                franchNotificationPayments: action.payload,
            };
        default:
            return state;
    }
};
